import { FormControl, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography } from '@mui/material';
import React, { forwardRef, useImperativeHandle } from 'react';
import ButtonService from '../ButtonService';
import { userCode, username } from '../../../services/ApiService';

import { useFormik } from 'formik';
import * as Yup from 'yup'
import CreateEditModalMaster from '../CreateEditModalMaster';
import { Input, showToast } from '../../../components/ui';

const CreateEditBillOfLading = forwardRef((props, ref) => {
    const { isModal, handleClick, titleModal, title, param, selectedData, getData } = props

    const simpanLocal = () => {
        if (isModal) {
            const data = {
                "billOfLading": {
                    ...formik.values,
                    rowStatus: formik?.values?.rowStatus || 'ACT',
                    titleModal,
                    user: userCode,
                }
            }
            localStorage.setItem(username + "-DataBillOfLading", JSON.stringify(data));
        }
    }

    useImperativeHandle(ref, () => ({

        localSave() {
            simpanLocal()
        }

    }));

    const validationSchema = Yup.object().shape({
        name: Yup.string().trim().required('This field is required.'),
        abbreviation: Yup.string().nullable(),
        shipmentBy: Yup.string().trim().required('This field is required.'),
        description: Yup.string().nullable(),
    })

    const formik = useFormik({
        initialValues: selectedData?.id ? { ...selectedData } : {
            name: '',
            abbreviation: '',
            shipmentBy: '',
            description: '',
        },
        validationSchema,
        onSubmit: (values) => Save(values)
    })

    const Save = (payload) => {
        if (payload?.name === '') {
            return showToast({ type: 'error', message: 'Name is Required!' });
        }

        if (payload?.billOfLadingCode === '') {
            return showToast({ type: 'error', message: 'Bill of Lading Code is Required!' });
        }

        if (payload?.abbreviation === '') {
            return showToast({ type: 'error', message: 'Abbreviation is Required!' });
        }

        if (payload?.shipmentBy === '') {
            return showToast({ type: 'error', message: 'Shipment By is Required!' });
        }

        const data =
        {
            "billOfLading": {
                "rowStatus": "ACT",
                "id": payload?.id,
                "name": payload?.name,
                "billOfLadingCode": payload?.billOfLadingCode,
                "abbreviation": payload?.abbreviation,
                "shipmentBy": payload?.shipmentBy,
                "description": payload?.description,
                "user": userCode
            }
        }

        ButtonService.Save(titleModal, title, param, data, () => {
            getData(1, 50, []);
            handleClick();
        });
    }

    const mainContainer = (
        <form onSubmit={formik.handleSubmit} style={{ marginTop: '12px' }}>
            <Input
                name="name"
                label={'Name'}
                value={formik.values.name}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('name', e.target.value)}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.touched.name && formik.errors.name}
                formControlProps={{
                    sx: {
                        width: '100%',
                        // marginTop: '16px'
                    }
                }}
            />

            <Input
                name="abbreviation"
                label={'Abbreviation'}
                value={formik.values.abbreviation}
                onBlur={formik.handleBlur}
                onChange={(e) => formik.setFieldValue('abbreviation', e.target.value)}
                error={formik.touched.abbreviation && Boolean(formik.errors.abbreviation)}
                helperText={formik.touched.abbreviation && formik.errors.abbreviation}
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '16px'
                    }
                }}
            />

            <FormControl
                style={{ marginTop: '16px' }}
                error={formik.touched.shipmentBy && Boolean(formik.errors.shipmentBy)}
            >
                <Typography
                    sx={{
                        color: 'var(--Primary-One, #083A50)',
                        fontFamily: 'Nunito',
                        fontSize: '14px',
                        fontStyle: 'normal',
                        fontWeight: '600',
                        lineHeight: '19.6px',
                    }}
                >
                    Shipment By
                </Typography>

                <RadioGroup
                    row
                    aria-labelledby="variant-option"
                    name="variant"
                    value={formik.values.shipmentBy}
                    onChange={(e) => formik.setFieldValue('shipmentBy', e.target.value)}
                >
                    <FormControlLabel
                        sx={{
                            color: 'var(--Blue-Primary-1, #083A50)',
                            fontFamily: 'Nunito',
                            fontSize: '12px !important',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            lineHeight: '20px',
                        }}
                        value={'Sea'}
                        key={0}
                        control={<Radio size='small' />}
                        label={
                            <Typography
                                sx={{
                                    color: 'var(--Blue-Primary-1, #083A50)',
                                    fontFamily: 'Nunito',
                                    fontSize: '12px !important',
                                    fontStyle: 'normal',
                                    fontWeight: '500',
                                    lineHeight: '20px',
                                }}
                            >
                                SEA
                            </Typography>
                        }
                    />

                    <FormControlLabel
                        sx={{
                            color: 'var(--Blue-Primary-1, #083A50)',
                            fontFamily: 'Nunito',
                            fontSize: '12px !important',
                            fontStyle: 'normal',
                            fontWeight: '400',
                            lineHeight: '20px',
                        }}
                        value={'Air'}
                        key={1}
                        control={<Radio size='small' />}
                        label={
                            <Typography
                                sx={{
                                    color: 'var(--Blue-Primary-1, #083A50)',
                                    fontFamily: 'Nunito',
                                    fontSize: '12px !important',
                                    fontStyle: 'normal',
                                    fontWeight: '500',
                                    lineHeight: '20px',
                                }}
                            >
                                AIR
                            </Typography>
                        }
                    />
                </RadioGroup>
                <FormHelperText>{formik.touched.shipmentBy && formik.errors.shipmentBy}</FormHelperText>
            </FormControl>

            <Input
                id='description'
                name="description"
                label="Description"
                value={formik.values.description}
                multiline
                fullWidth
                formControlProps={{
                    sx: {
                        width: '100%',
                        marginTop: '8px'
                    }
                }}
                inputBaseProps={{
                    rows: 4,
                    sx: {
                        padding: '8px',
                    },
                }}
                onChange={(e) => formik.setFieldValue('description', e.target.value)}
            />
        </form>
    )

    return (
        <>
            {
                isModal && (
                    <CreateEditModalMaster
                        isModal={isModal}
                        titleModal={titleModal}
                        title={title}
                        mainContainer={mainContainer}
                        handleClick={handleClick}
                        handleSave={() => Save(formik.values)}
                    />
                )
            }
        </>
    )
})

export default CreateEditBillOfLading